import { render, staticRenderFns } from "./LeaveBalance.vue?vue&type=template&id=66b03926&scoped=true"
import script from "./LeaveBalance.vue?vue&type=script&lang=js"
export * from "./LeaveBalance.vue?vue&type=script&lang=js"
import style0 from "./LeaveBalance.vue?vue&type=style&index=0&id=66b03926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b03926",
  null
  
)

export default component.exports